export default __webpack_public_path__ + "static/media/530.e84e927d.png";